// extracted by mini-css-extract-plugin
export var cardHeader = "_s5-0";
export var reorderHandle = "_s5-3";
export var titleArea = "_s5-1";
export var titleAreaWithHandle = "_s5-2";